import Peninsula1 from "./peninsula (1).webp";
import Peninsula2 from "./peninsula (2).webp";
import Peninsula3 from "./peninsula (3).webp";

const peninsula = [Peninsula1, Peninsula2, Peninsula3];

export default peninsula;
